import Vue from 'vue'
import Vuex from 'vuex'
import { login, PhoneLogin, MemRegister, shopCartList, addCart, deleteCart } from './request/api'
import axios from 'axios'
import { Toast } from 'vant'


Vue.use(Vuex)

const state = {
  LOADING: false,
  status: '',
  token: '',
  user: {},
  cartList: ((localStorage.getItem('cartList') == undefined) || (localStorage.getItem('cartList') == 'undefined')) ? [] : JSON.parse(localStorage.getItem('cartList'))
}

const mutations = {
  showLoading(state) {
    state.LOADING = true
  },
  hideLoading(state) {
    state.LOADING = false
  },
  auth_request(state) {
    state.status = 'loading'
  },
  auth_success(state, data) {
    state.status = 'success',
      state.token = data.token,
      state.user = data
  },
  auth_error(state) {
    state.error = 'error'
  },
  logout(state) {
    state.status = '',
      state.token = ''
  },
  //购物车列表
  get_cart(state, cartlist) {
    state.cartList = cartlist
  },
  //添加到购物车
  addGoods(state, data) {
    state.cartList.push(data)
  },

  //商品删除
  delete_Cart(state) {
    state.cartList = state.cartList.filter(item=>{
      return !item.checked
    })
    // localStorage.setItem('cartList', JSON.stringify(state.cartList));
  },
}

const actions = {
  //用户名密码登录
  Login({ commit }, user) {
    login(user).then(res => {
      if (res.status == 200) {
        const token = res.data.token
        const userinfo = JSON.stringify(res.data)
        localStorage.setItem('token', token)
        localStorage.setItem('userInfo', userinfo)
        // axios.defaults.headers.common['Authorization'] = token
        commit('auth_success', res.data)
        // resolve(res)
      } else {
        Toast({
          message: res.msg
        })
      }
    }).catch(error => {
      commit('auth_error')
      localStorage.removeItem('token')
      // reject(error)
    })
  },
  // 手机号验证码登录
  PhoneLogin({ commit }, user) {
    return new Promise((resolve, reject) => {
      commit('auth_request')
      PhoneLogin(user).then(res => {
        if (res.status == 200) {
          const token = res.data.token
          const user = res.data
          localStorage.setItem('token', token)
          localStorage.setItem('userInfo', user)
          commit('auth_success', user)
          resolve(res)
        } else {
          Toast({
            message: res.msg
          })
        }
      }).catch(error => {
        commit('auth_error')
        localStorage.removeItem('token')
        reject(error)
      })
    })
  },
  //注册
  Register({ commit }, user) {
    return new Promise((resolve, reject) => {
      commit('auth_request')
      MemRegister(user).then(res => {
        if (res.status == 200) {
          const token = res.data.token
          const user = res.data
          localStorage.setItem('token', token)
          localStorage.setItem('userInfo', user)
          commit('auth_success', user)
          resolve(res)
        } else {
          Toast({
            message: res.msg
          })
        }
      }).catch(error => {
        commit('auth_error')
        localStorage.removeItem('token')
        reject(error)
      })
    })
  },

  //获取购物车
  getCartList({ commit }) {
    return new Promise((resolve, reject) => {
      shopCartList({}).then(res => {
        if (res.status == 200) {
          let data = res.data;
          data.forEach(el => {
            Vue.set(el, 'checked', false)
            Vue.set(el, 'count', 1)
          });
          localStorage.setItem('cartList', JSON.stringify(data))
          commit('get_cart', data)
          resolve(res)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },

  //添加到购物车
  addCartList({ commit }, params) {
    return new Promise((resolve, reject) => {
      // 查找购物车列表里面是否存在要添加的商品
      // let carts = JSON.parse(localStorage.getItem('cartList'))
      let idExist = state.cartList.find((item) => {
        return item.stockId == params.stockId
      })
      // 如果没有相同商品在购物车，那么添加
      if (!idExist) {
        addCart(params).then(res => {
          if (res.status == 200) {
            Toast.success({
              message: '成功添加购物车',
              duration: 700
            })
            commit('addGoods', params)
            localStorage.setItem("cartList", JSON.stringify(state.cartList));
            resolve(res)
          } else {
            Toast({
              message: res.msg,
              duration: 700
            })
          }
        }).catch(error => {
          reject(error)
        })
      } else {
        //否则提示购物车已有商品
        Toast({
          message: '购物车已存在此商品',
          duration: 700
        })
      }
    })
  },
  //商品删除
  deleteCart({ commit }, params) {
    return new Promise((resolve, reject) => {
      deleteCart({ data: params }).then(res => {
        if (res.status == 200) {
          Toast.success({
            message: '删除成功',
            duration: 700
          })
          commit('delete_Cart', params)
          localStorage.setItem('cartList', JSON.stringify(state.cartList))
          resolve(res)
        }
      }).catch(error => {
        reject(error)
      })
    })
  }

}

const getters = {
  isLoggedIn: state => !!state.token,
  authStatus: state => state.status,
  //获取购物车总数量
  getAllCount(state) {
    var sum = 0;
    state.cartList.forEach(item => {
      sum += item.count;
    })
    return sum;
  },
}

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters
})
